import React from "react";
import { Checkbox } from "../../ui/checkbox";

export function CheckboxField({
  item,
  value,
  error,
  helperText,
  disabled,
  onCheckedChange,
  className,
  labelClassName,
}) {
  // Handle both single checkbox (item.label) and multiple checkboxes (item.values)
  return (
    <div className="flex flex-col space-y-2">
      {item.values.map((listItem, index) => {
        const isChecked = value === listItem.value;
        return (
          <Checkbox
            key={listItem.label || index}
            id={`${item.id || item.pathToValue}-${index}`}
            checked={isChecked}
            onCheckedChange={() => {
              const newValue = !isChecked ? listItem.value : null;
              onCheckedChange(newValue);
            }}
            disabled={disabled}
            error={error}
            label={listItem.label}
            errorMessage={error ? helperText : undefined}
            className={className}
            labelClassName={labelClassName}
          />
        );
      })}
    </div>
  );
}
